module.exports = __webpack_public_path__ + "img/icon-Agenda-Blue.e8b59a90.png";